import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import Flex from 'components/Flex'

const createEntranceKeyframes = (x, y) => keyframes`
  from {
    transform: translateX(${x}) translateY(${y});
    opacity: 0;
  }
  to {
    transform: translateX(0) translateY(0);
    opacity: 1;
  }
`

const createExitKeyframes = (x, y) => keyframes`
  from {
    transform: translateX(0) translateY(0);
    opacity: 1;
  }
  to {
    transform: translateX(${x}) translateY(${y});
    opacity: 0;
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const entrances = {
  top: createEntranceKeyframes('0', '-50px'),
  right: createEntranceKeyframes('50px', '0'),
  bottom: createEntranceKeyframes('0', '50px'),
  left: createEntranceKeyframes('-50px', '0'),
  fade: fadeIn
}

export const exits = {
  top: createExitKeyframes('0', '-50px'),
  right: createExitKeyframes('50px', '0'),
  bottom: createExitKeyframes('0', '50px'),
  left: createExitKeyframes('-50px', '0'),
  fade: fadeOut
}

const ModalContainer = styled(Flex)`
  position: fixed;
  top: 0;
  overflow: auto;
  height: 100%;
  width: 100%;
  pointer-events: none;
  animation-name: ${props => props.show ? entrances[props.slideInAnimation] : exits[props.slideInAnimation]};
  animation-duration: ${props => props.transitionDuration}ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  & > * {
    pointer-events: all;
  }
`
ModalContainer.propTypes = {
  show: PropTypes.bool.isRequired,
  slideInAnimation: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'fade']),
  transitionDuration: PropTypes.number.isRequired
}
ModalContainer.defaultProps = {
  slideInAnimation: 'fade'
}

export default ModalContainer
